import { Box } from "@mui/material"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import { useLogbookContext } from "./context"
import { TabsItem, } from "./utils"
import { ActivityRegister, } from "./components"
import { Access } from "./components/access"
import { ActivitiesCatalog } from "./components/catalog"
import { MyActivity } from "./components/myActivity"
import { useEffect } from "react"
import { ActionTabs } from "./components/shared/actionsTabs"
import { useLocation } from "react-router-dom"
import { Hashs } from "./components/activityRegister/utils"
import { DailyCuts } from "./components/dailyCuts"
import { BreadCrumb } from "../../../../components"
import { DestinationsRegistered } from "./components/destinationRegistered"

export const Main = () => {
    const location = useLocation()
    const hash = location.hash
    const existHash = [Hashs.DETAIL, Hashs.CREATE, Hashs.EDIT].some(h => hash.includes(h))
    const { listTab, state, changeTab, service } = useLogbookContext()
    useEffect(() => {
        if (!existHash) {
            service.getAreaItem()
            service.getDepartmentItem()
            service.getStoreItem()
            service.getRoleItem()
            service.getDivisionItem()
            service.getUserTypeItem()
            service.getStatusItem()
            service.getUsersItem()
            service.datesItems()
        }
    }, [location.hash])
    return (
        <>
            <Box className="main-container">
                <BreadCrumb
                    notAddPath
                />
                <Box>
                    <CustomeTab
                        listTab={listTab}
                        value={state.tab}
                        justifyContent="start"
                        endChildrenTab={!existHash ? <ActionTabs tab={state.tab} /> : undefined}
                        tabList={{ onChange: (_, value) => { changeTab({ value }) } }}
                    >
                        <CustomePanel value={TabsItem.ACTIVITY_REGISTER}> <ActivityRegister /> </CustomePanel>
                        <CustomePanel value={TabsItem.MY_ACTIVITY}> <MyActivity /> </CustomePanel>
                        <CustomePanel value={TabsItem.DAILYCUTS}> <DailyCuts /> </CustomePanel>
                        <CustomePanel value={TabsItem.ACCESS}> <Access /> </CustomePanel>
                        <CustomePanel value={TabsItem.CATALOG}> <ActivitiesCatalog /> </CustomePanel>
                        <CustomePanel value={TabsItem.DESTINATION_REGISTERED}> <DestinationsRegistered /> </CustomePanel>
                    </CustomeTab>
                </Box>
            </Box>
        </>
    )
}